export enum DatiqPanelPopupPosition {
    UnderLabel = 'UnderLabel',
    RightBottom = 'RightBottom',
    LeftBottom = 'LeftBottom',
    Unknown = 'Unknown',
}

export enum DatiqPanelPopupScrollStrategy {
    Noop = 'noop',                  // Do nothing on scroll.
    Close = 'close',                // Close the overlay as soon as the user scrolls.
    Block = 'block',                // Block scrolling.
    Reposition = 'reposition',      // Update the overlay's position on scroll.
}